import { AbstractScatterVisualization } from '../visualization.abstract.scatter.component';
export class OneClassSVMGraph extends AbstractScatterVisualization {
}
